import React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';

function UnregisterEntity(props) {
  const {
    unregisterEntityOptions,
    isUnregisterAllowed,
    onUnregisterEntity,
    onClose
  } = props;
  const isBoolean = typeof unregisterEntityOptions?.disableUnregister === "boolean";
  const isDisabled = (!isUnregisterAllowed || (isBoolean ? !!unregisterEntityOptions?.disableUnregister : unregisterEntityOptions?.disableUnregister === "disable")) ?? false;
  let unregisterButton = /* @__PURE__ */ React.createElement(React.Fragment, null);
  if (unregisterEntityOptions?.disableUnregister !== "hidden") {
    unregisterButton = /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        onClick: () => {
          onClose();
          onUnregisterEntity();
        },
        disabled: isDisabled
      },
      /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(CancelIcon, { fontSize: "small" })),
      /* @__PURE__ */ React.createElement(ListItemText, { primary: "Unregister entity" })
    );
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, unregisterButton);
}

export { UnregisterEntity };
//# sourceMappingURL=UnregisterEntity.esm.js.map
